import { gql } from "@apollo/client";
import { PaginationInput } from "types";

export interface ProfileFilterInput {
  channel?: string;
  profileType?: string;
  connected?: boolean;
  search?: string;
}

export interface IFilterProfilesVars {
  paginationInput: PaginationInput;
  filterInput?: ProfileFilterInput;
}

export interface IProfileRow {
  id: string;
  channel: string;
  channelUserId: string;
  displayName?: string;
  profileType?: string;
  connectedUserId?: string;
  connectedAt?: string;
  termsAcceptedAt?: string;
  socials?: {
    website?: string;
    linkedin?: string;
    instagram?: string;
    facebook?: string;
  };
  connectedUser?: { id: string; email: string; fullName?: string };
  createdAt: string;
  updatedAt?: string;
}

export interface IFilterProfiles {
  filterProfilesPaginated: {
    data: IProfileRow[];
    paginationInfo: any;
  };
}

export const FILTER_PROFILES_PAGINATED = gql`
  query filterProfilesPaginated(
    $paginationInput: PaginationInput!
    $filterInput: ProfileFilterInput
  ) {
    filterProfilesPaginated(paginationInput: $paginationInput, filterInput: $filterInput) {
      data {
        id
        channel
        channelUserId
        displayName
        profileType
        connectedUserId
        connectedAt
        termsAcceptedAt
        socials {
          website
          linkedin
          instagram
          facebook
        }
        connectedUser {
          id
          email
          fullName
        }
        createdAt
        updatedAt
      }
      paginationInfo {
        currentPage
        perPage
        pageCount
        itemCount
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
